import { defineComponent as _defineComponent } from 'vue'
import CatapultBanner from './CatapultBanner.vue';
import { CatalogState } from 'JS/catalog/store/store';
import { computed } from 'vue';
import { ICatapultBanner } from '../sponsored-types';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatapultBannerApp',
  setup(__props) {

const store = useLegacyVuexStore<CatalogState>();

const catapultBanner = computed<ICatapultBanner>(() => {
	return store.state.epsilonAds?.catapultBanner;
});



return { __sfc: true,store, catapultBanner, CatapultBanner }
}

})